export const categories = [
  { slug: 'daily-contest', name: '每日大赛', icon: 'ri-live-line', description: '每日热点赛事实时追踪，最新网红动态一网打尽' },
  { slug: 'celebrity-gossip', name: '网红吃瓜', icon: 'ri-user-smile-line', description: '网红圈最新八卦爆料，吃瓜第一线' },
  { slug: 'scandal-gate', name: '黑料门', icon: 'ri-alert-line', description: '深度曝光黑料事件，还原事实真相' },
  { slug: 'contrast-video', name: '反差视频', icon: 'ri-movie-line', description: '网红反差瞬间精选，台前幕后大不同' },
  { slug: 'borderline', name: '擦边内容', icon: 'ri-fire-line', description: '擦边内容合集，精彩不容错过' },
  { slug: 'platform-exclusive', name: '独家爆料', icon: 'ri-lock-line', description: '平台独家爆料内容，只在五一黑料' },
];